"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSecondarySupplier_1 = require("../model/ProductSecondarySupplier");

var ProductSecondarySupplierConverter_1 = require("./ProductSecondarySupplierConverter");
/**
 * @author VRu
 */


var ProductSecondarySupplierConverterImpl =
/*#__PURE__*/
function (_ProductSecondarySupp) {
  _inherits(ProductSecondarySupplierConverterImpl, _ProductSecondarySupp);

  function ProductSecondarySupplierConverterImpl() {
    _classCallCheck(this, ProductSecondarySupplierConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSecondarySupplierConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSecondarySupplierConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSecondarySupplier_1.ProductSecondarySupplier(ProductSecondarySupplier_1.ProductSecondarySupplier.schema.id.valueOf(conversions.documentToClassId(source)), ProductSecondarySupplier_1.ProductSecondarySupplier.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), ProductSecondarySupplier_1.ProductSecondarySupplier.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductSecondarySupplier_1.ProductSecondarySupplier.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return Object.assign(Object.assign({}, conversions.classToDocumentId(source)), {
        productId: conversions.toDocumentReferenceId(source.productId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        processed: source.processed
      });
    }
  }]);

  return ProductSecondarySupplierConverterImpl;
}(ProductSecondarySupplierConverter_1.ProductSecondarySupplierConverter);

exports.ProductSecondarySupplierConverterImpl = ProductSecondarySupplierConverterImpl;